// removed by extract-text-webpack-plugin
module.exports = {"moveBtnContainer":"index__moveBtnContainer___6pXhB","moveBtn":"index__moveBtn___hMF_p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/ObjectFilter/components/index.less
// module id = 1794
// module chunks = 3